export default {
  noDataFound: 'Empty',
  loading: 'loading',
  createTime: 'Create Time',
  done: 'Done',
  fail: 'Fail',
  processing: 'Processing',
  brand: 'Brand',
  submit: 'Submit',
  // 公共文本
  'commons.labels.username': 'username',
  'commons.labels.password': 'password',
  'commons.labels.selectSite': 'Please select a service site',
  'commons.buttons.login': 'login',
  'commons.buttons.confirm': 'Confirm',
  'commons.buttons.cancel': 'Cancel',
  'commons.buttons.modify': 'Modify',
  'commons.buttons.delete': 'Delete',
};
